import { SERVICES_API_BASE_URL } from './apiConfig';

export interface EmailConnection {
  provider: number;
  email: string;
  connectedAt: string;
}

export interface YahooSMTPRequest {
  email: string;
  password: string;
  smtpHost: string;
  smtpPort: number;
}

const API_URL = `${SERVICES_API_BASE_URL}/api/emailconnection`;

const getAuthHeader = () => ({
  'Authorization': `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

/**
 * Fetch current active email connection
 */
export const getEmailConnection = async (): Promise<EmailConnection | null> => {
  try {
    const response = await fetch(`${API_URL}/active`, {
      headers: getAuthHeader(),
    });
    if (!response.ok) return null;
    return response.json();
  } catch (err) {
    console.error('Failed to fetch email connection:', err);
    return null;
  }
};

/**
 * Disconnect current email provider
 */
export const disconnectEmail = async (): Promise<void> => {
  const response = await fetch(`${API_URL}/disconnect`, {
    method: 'DELETE',
    headers: getAuthHeader(),
  });
  if (!response.ok) throw new Error('Failed to disconnect email');
};

/**
 * Connect Yahoo email via SMTP
 */
export const connectYahooSMTP = async (data: YahooSMTPRequest): Promise<void> => {
  const response = await fetch(`${API_URL}/smtp/connect`, {
    method: 'POST',
    headers: getAuthHeader(),
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to connect Yahoo email');
  }
};

/**
 * Get Microsoft OAuth authorization URL
 */
export const getMicrosoftConnectUrl = async (): Promise<string> => {
  try {
    const response = await fetch(`${API_URL}/microsoft/connect`, {
      headers: getAuthHeader(),
    });

    if (!response.ok) throw new Error('Failed to get Microsoft auth URL');

    const data = await response.json();
    return data.authUrl || '';
  } catch (err) {
    console.error('Failed to get Microsoft connect URL:', err);
    throw err;
  }
};

/**
 * Get Google OAuth authorization URL
 */
export const getGoogleConnectUrl = async (): Promise<string> => {
  try {
    const response = await fetch(`${API_URL}/google/connect`, {
      headers: getAuthHeader(),
    });

    if (!response.ok) throw new Error('Failed to get Google auth URL');

    const data = await response.json();
    return data.authUrl || '';
  } catch (err) {
    console.error('Failed to get Google connect URL:', err);
    throw err;
  }
};

